import { AfterLoadEventHandler, CreateOptionsParams, ISpecializedCombo, useCombo } from "@hooks/useCombo"
import { IEnumRecord } from "@hooks/useRequest"
import { MenuItem } from "@material-ui/core"
import { useVendedorMovimentacaoService } from "@services/VendedorMovimentacaoService"
import { useThemeColor } from "@themes/Colors"
import { KeyOfEnum } from "@utils/TypeHelpers"
import React from "react"
import ILinha from "./Linha"
import { IVendedor } from "./Vendedor"

export enum VendedorMovimentacaoTipoEnum {
    None = 0,
    Atribuicao = 1,
    Resgate = 2
}

export interface IVendedorMovimentacao {
    vendedorMovimentacaoId: number
    vendedorId: number
    
    tipo: IEnumRecord<VendedorMovimentacaoTipoEnum>
    
    dataHora: Date
    competencia: string

    vendedor: IVendedor

    vendedorMovimentacaoLinhas: ILinha[]
}

export function useVendedorMovimentacaoTipoColor () {
    const themeColor = useThemeColor();

    const map : KeyOfEnum<VendedorMovimentacaoTipoEnum, string> = React.useMemo(() => ({
        [VendedorMovimentacaoTipoEnum.None]: "",
        [VendedorMovimentacaoTipoEnum.Atribuicao]: themeColor.status.verde,
        [VendedorMovimentacaoTipoEnum.Resgate]: themeColor.status.azul,
    }), [themeColor.status.azul, themeColor.status.verde]);

    return React.useMemo(() => map, [map]);
}

export type IComboVendedorMovimentacaoTipo = ISpecializedCombo<IEnumRecord<VendedorMovimentacaoTipoEnum>>;


export function useVendedorMovimentacaoTipoCombo () : IComboVendedorMovimentacaoTipo {
    const combo = useCombo<IEnumRecord<VendedorMovimentacaoTipoEnum>>();

    const vendedorMovimentacaoService = useVendedorMovimentacaoService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((enumerator, index) => {
            return <MenuItem key={index} value={enumerator.value}>{params?.prefix}{enumerator.description}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback((afterLoad?: AfterLoadEventHandler<IEnumRecord<VendedorMovimentacaoTipoEnum>>) => {
        combo.load(vendedorMovimentacaoService.listarTipos, afterLoad)
    }, [combo, vendedorMovimentacaoService.listarTipos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}
